/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { dashboardPanelEntryPoint } from '@jira/itam__ham-dashboard/src/dashboardPanelEntryPoint.entrypoint.tsx';
import { overviewEntryPoint } from '@jira/itam__ham-overview/src/overviewEntryPoint.entrypoint.tsx';
import { assetsEntryPoint } from '@jira/itam__ham-assets/src/assetsEntryPoint.entrypoint.tsx';
import { assetModelsEntryPoint } from '@jira/itam__ham-asset-models/src/assetModelsEntryPoint.entrypoint.tsx';
import { stockroomsEntryPoint } from '@jira/itam__ham-stockrooms/src/stockroomsEntryPoint.entrypoint.tsx';
import { workItemsEntryPoint } from '@jira/itam__ham-work-items/src/workEntryPoint.entrypoint.tsx';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JSResourceForInteraction } from '@atlassian/react-async';

type ItamEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const itamEntryPoint: EntryPoint<ItamEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForInteraction<ItamEntryPointComponent>(
			/* eslint-disable-next-line @atlassian/react-entrypoint/entrypoint-root-module-path */
			/* webpackChunkName: "async-itam-entrypoint", jiraSpaEntry: "async-itam-entrypoint" */ './ItamPage.tsx',
		),
		getPreloadProps: ({ context: { query } }: EntryPointRouteParams) => {
			const { tab } = query;
			if (tab === 'hardware') {
				return {
					entryPoints: {
						assetsEntryPoint: {
							entryPoint: assetsEntryPoint,
						},
					},
				};
			}
			if (tab === 'models') {
				return {
					entryPoints: {
						assetModelsEntryPoint: {
							entryPoint: assetModelsEntryPoint,
						},
					},
				};
			}
			if (tab === 'stockrooms') {
				return {
					entryPoints: {
						stockroomsEntryPoint: {
							entryPoint: stockroomsEntryPoint,
						},
					},
				};
			}
			if (tab === 'work') {
				return {
					entryPoints: {
						workEntryPoint: {
							entryPoint: workItemsEntryPoint,
						},
					},
				};
			}
			if (tab === 'dashboard') {
				return {
					entryPoints: {
						dashboardPanelEntryPoint: {
							entryPoint: dashboardPanelEntryPoint,
						},
					},
				};
			}
			// Overview tab (and default): preload overview entry point
			return {
				entryPoints: {
					overviewEntryPoint: {
						entryPoint: overviewEntryPoint,
					},
				},
			};
		},
	});
